import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class StarDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"ETOILE"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "ETOILE",
            player: event.detail?.player,
          };
    }

    get player() {
        return this.detail.player;
    }
    set player(value) {
        this.detail.player = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
        
        // On peut modifier le text et le title
        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "team", "player"].includes(key)){
            let commentaire = "L'étoile du match est "

            const starPlayer = getPlayer(this.player, match)
            const team = getTeam(this.team, match)

            if(this.player){
                if(starPlayer){
                    commentaire += starPlayer.lastname
                }
            }else if(team){
                commentaire += 'pour '+ team.name
            }

            commentaire += "! "


            this.text = commentaire
        }
    }
}